import { initConstructorBeacon } from '@/shared/instances/constructor-beacon';

initConstructorBeacon();
